export type ClientEvent = "message.submit" | "message.cancel" | "turn.attach" | "typing.heartbeat" | "turn.delivered"
export type ServerEvent = "turn.accepted" | "turn.attached" | "status.update" | "llm.thinking"
  | "tool.batch.started" | "tool.batch.completed" | "answer.started" | "answer.delta"
  | "turn.settling" | "answer.final" | "turn.error" | "conversation.updated"
  | "conversation.compaction" | "turn.cancel.requested"
export type SocketEnvelope<E extends string = string> = { event: E; event_id: string; ts: string; payload: Record<string, unknown> }

export function parseSocketEnvelope(data: unknown): SocketEnvelope | null {
  try {
    const value = JSON.parse(String(data))
    if (!value || typeof value !== "object" || typeof value.event !== "string" || !value.payload || typeof value.payload !== "object" || Array.isArray(value.payload)) return null
    return { event: value.event, event_id: typeof value.event_id === "string" ? value.event_id : "", ts: typeof value.ts === "string" ? value.ts : "", payload: value.payload }
  } catch { return null }
}
